import * as React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { downloadCSV, extractAndDelete } from "../utils";
import HwsIn from "./tables/hwsIn";
import HwsOut from "./tables/hwsout";
import {
  Grid,
  Typography,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import Button from "@mui/material/Button";
import { callHwsSwap, cleanApiResponse } from "../redux/dynamo_db/actions";
import { getContractDetails } from "../redux/contract/actions";
import Contracts from "./tables/contracts";
import MaterialSearch from "./tables/materialSearch";

export default function HwsSwapDetail() {
  const dispatch = useDispatch();
  const [selectedSerialNumber, setSelectedSerialNumber] = useState(null);
  const [openConfirmModal, setOpenConfirmModal] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const location = useLocation();
  let hwsIdentifier = decodeURIComponent(
    location.pathname.split("/")[location.pathname.split("/").length - 1],
  );
  // The parse/stringify cheap cloning trick is to create a local copy of the state object
  const hwsSnTrail = useSelector((state) => {
    let _hwsSnTrail = state?.hwsSnsTrail?.find((c) => c.SK === hwsIdentifier);
    if (_hwsSnTrail) {
      return JSON.parse(JSON.stringify(_hwsSnTrail));
    } else return {};
  });
  const _apiResponse = useSelector((state) =>
    state.apiResponse?.source === "CALL_HWS_SWAP"
      ? state.apiResponse.message
      : null,
  );

  React.useEffect(() => {
    dispatch(cleanApiResponse());
  }, []);
  const handleExportHwsSwap = () => {
    const fields = [
      { name: "serial_number_hws_in" },
      { name: "business_partner_hws_in" },
      { name: "serial_number_hws_out" },
    ];
    const hwsSwapSns = {
      serial_number_hws_in: hwsSnTrail?.serial_number_hws_in,
      business_partner_hws_in: hwsSnTrail?.business_partner_hws_in,
      serial_number_hws_out:
        selectedSerialNumber === hwsSnTrail?.serial_number_hws_out
          ? hwsSnTrail?.serial_number_hws_out
          : null,
    };
    // Wrap single object in array for consistent processing
    const data = hwsSwapSns ? [hwsSwapSns] : [];
    downloadCSV(fields, "hws_swap_export", ",", data);
  };
  const handleHwsSwap = () => {
    const hwsSwapSns = {
      serial_number_hws_in: hwsSnTrail?.serial_number_hws_in,
      business_partner_hws_in: hwsSnTrail?.business_partner_hws_in,
      serial_number_hws_out: selectedSerialNumber,
      hws_swap_trail_id: hwsSnTrail?.SK,
    };
    dispatch(callHwsSwap(hwsSwapSns));
  };

  const checkHwsSwap = () => {
    if (selectedSerialNumber === null) {
      setOpenModal(true);
    } else {
      setOpenConfirmModal(true);
    }
  };

  const hwsSnTrailClone = JSON.parse(JSON.stringify(hwsSnTrail));
  const hwsSnTrailInFields = [
    { name: "Serial Number", key: "serial_number_hws_in" },
    { name: "Arrival date", key: "hws_in_arrival_date" },
    { name: "Order ID", key: "hws_order_id" },
    { name: "Base Order Line", key: "hws_base_order_line" },
    { name: "Part Number", key: "part_number_hws_in" },
    { name: "Applicant Id", key: "applicant_id_hws_in" },
    { name: "Business Partner CRD Id", key: "business_partner_hws_in" },
    { name: "Support Partner CRD Id", key: "support_partner_hws_in" },
    { name: "End Customer Id", key: "end_customer_hws_in" },
    { name: "Bundle reference", key: "bundle_reference_hws_in" },
    { name: "Swap Status", key: "status" },
    { name: "Replaced by", key: "replaced_by" },
    { name: "Swap date", key: "swap_date" },
    { name: "Error Reason", key: "error_reason" },
  ];

  const hwsSnTrailInDetails = hwsSnTrailInFields.map(({ name, key }) => ({
    name,
    value: extractAndDelete(hwsSnTrailClone, key) || "",
  }));

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <HwsIn hwsSnTrailInDetails={hwsSnTrailInDetails} />
        <div />
      </div>
      <div style={{ marginBottom: "1%" }} />
      <Dialog open={openConfirmModal} maxWidth="xs" fullWidth>
        <DialogContent>
          <Typography variant="body2">
            This will swap all entitlements and relationship from one serial
            number to the other, are you sure you want to continue?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              handleHwsSwap();
              setOpenConfirmModal(false);
            }}
          >
            Yes
          </Button>

          <Button variant="text" onClick={() => setOpenConfirmModal(false)}>
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openModal} maxWidth="xs" fullWidth>
        <DialogContent>
          <Typography variant="body2">
            One serial number MUST be selected.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={() => setOpenModal(false)}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Contracts
        getContractDetails={getContractDetails}
        serialNumberHwsIn={hwsSnTrail?.serial_number_hws_in}
        businessPartnerHwsIn={hwsSnTrail?.business_partner_hws_in}
      />
      <MaterialSearch hwsSnTrailInDetails={hwsSnTrail} />
      <HwsOut
        hwsSnTrail={hwsSnTrail}
        selectedSerialNumber={selectedSerialNumber}
        setSelectedSerialNumber={setSelectedSerialNumber}
      />
      <Grid
        container
        style={{
          justifyContent: "center",
        }}
      >
        <Grid item>
          <Button
            variant="contained"
            onClick={handleExportHwsSwap}
            style={{ width: "15vw" }}
          >
            Export
          </Button>
        </Grid>
        <div style={{ paddingLeft: "0.2%" }} />
        <Grid item>
          <Button
            variant="contained"
            onClick={checkHwsSwap}
            style={{ width: "15vw" }}
          >
            Swap
          </Button>
        </Grid>
      </Grid>
      {/* Conditional rendering of Swap Result */}
      {_apiResponse && (
        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <Typography variant="h6">Swap Result: {_apiResponse}</Typography>
        </div>
      )}
    </>
  );
}
